module.exports = __webpack_public_path__ + "assets/img/logo.cfd6a40a.png";